import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatIcon } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import { MatSlideToggle } from '@angular/material/slide-toggle'

@Component({
  selector: 'app-address-type-edit',
  imports: [
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatInputModule,
    MatSlideToggle,
  ],
  templateUrl: './address-type-edit.component.html',
  styleUrl: './address-type-edit.component.scss',
  providers: [AddressTypeService],
})
export class AddressTypeEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private addressTypeService: AddressTypeService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<AddressTypeEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.contactTypeItem = data
  }

  @Output() responseEdit = new EventEmitter()

  contactTypeItem: any = {}
  form: FormGroup = new FormGroup({})
  loading: boolean = false

  ngOnInit(): void {
    this.createForm()
  }

  updateAddressType() {
    this.loading = true
    const model = this.createModel()
    this.addressTypeService.editAddressType(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      id: this.contactTypeItem.id,
      descricao: this.form.controls['description'].value,
      ativo: this.form.controls['active'].value ? 'S' : 'N',
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      code: [
        { value: this.contactTypeItem.id, disabled: true },
        [Validators.required],
      ],
      active: [this.contactTypeItem.ativo == 'Ativo' ? true : false],
      description: [this.contactTypeItem.descricao, [Validators.required]],
    })
  }
}
